import { usePageTitle } from '@app/hooks/usePageTitle';
import RoutingHistoryWidget from '@widgets/routing/history';

const RoutingHistoryPage = () => {
  usePageTitle('Routing Versions');

  return <RoutingHistoryWidget />;
};

export default RoutingHistoryPage;
